import { Card } from '@mui/material';
import TwitterTimelineEmbed from '../../../components/TwitterTimelineEmbed';

function TwitterSection() {
  return (
    <Card>
      <TwitterTimelineEmbed id="fjmtkzk0821" theme="light" height="450"/>
    </Card>
  );
}

export default TwitterSection